var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPaperclip(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.6271 9.08296L10.1141 16.596C8.40556 18.3045 5.63546 18.3045 3.92692 16.596C2.21837 14.8874 2.21837 12.1173 3.92692 10.4088L11.4399 2.89578C12.579 1.75675 14.4257 1.75675 15.5647 2.89578C16.7037 4.0348 16.7037 5.88154 15.5647 7.02057L8.34633 14.2389C7.77682 14.8085 6.85345 14.8085 6.28394 14.2389C5.71442 13.6694 5.71442 12.7461 6.28394 12.1766L12.6184 5.84205",
    stroke: "#374562",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaperclip);
export default __webpack_public_path__ + "static/media/paperclip.750cabd620bfe9593cf0b33723966795.svg";
export { ForwardRef as ReactComponent };